import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { patchSettings } from "../../../redux/slices/UtilsSlice";
import toast from "react-hot-toast";

const DAYS = [
  { value: 1, label: "Lundi" },
  { value: 2, label: "Mardi" },
  { value: 3, label: "Mercredi" },
  { value: 4, label: "Jeudi" },
  { value: 5, label: "Vendredi" },
];

const DigDayOfficeConfigComp = ({ officeAllowedDaysOfWeek = [] }) => {
  const dispatch = useDispatch();
  const [selectedDays, setSelectedDays] = useState(officeAllowedDaysOfWeek);
  const [saving, setSaving] = useState(false);

  const toggleDay = (dayValue) => {
    setSelectedDays((prev) =>
      prev.includes(dayValue)
        ? prev.filter((d) => d !== dayValue)
        : [...prev, dayValue].sort((a, b) => a - b)
    );
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const result = await dispatch(
        patchSettings({ officeAllowedDaysOfWeek: selectedDays })
      );
      if (result?.payload?.status === 200) {
        toast.success("Configuration sauvegardée !");
      } else {
        toast.error("Erreur lors de la sauvegarde.");
      }
    } catch {
      toast.error("Erreur lors de la sauvegarde.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <h5>Jours de DigDay/FinDay autorisés au bureau</h5>
      <p className="text-muted" style={{ fontSize: "0.9rem" }}>
        Les jours non cochés griseront l'option "au bureau" dans l'application mobile.
      </p>
      <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", margin: "16px 0" }}>
        {DAYS.map((day) => (
          <label
            key={day.value}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              cursor: "pointer",
              fontSize: "1rem",
              userSelect: "none",
            }}
          >
            <input
              type="checkbox"
              checked={selectedDays.includes(day.value)}
              onChange={() => toggleDay(day.value)}
              style={{ width: "18px", height: "18px", cursor: "pointer" }}
            />
            {day.label}
          </label>
        ))}
      </div>
      <button
        className="btn btn-primary"
        onClick={handleSave}
        disabled={saving}
      >
        {saving ? "Sauvegarde..." : "Sauvegarder"}
      </button>
    </div>
  );
};

export default DigDayOfficeConfigComp;